import { useEffect, useRef, useState } from "react";

import Carousel from "react-simply-carousel";
import { saveAs } from "file-saver";

import useWindowDimensions from "hoc/useWindowDimensions";

import iconPrevious from "assets/img/iconPrevious.png";
import iconNext from "assets/img/iconNext.png";
import iconPreviousWhite from "assets/img/iconPrevious-white.png";
import iconNextWhite from "assets/img/iconNext-white.png";
import download from "assets/img/download.png";

export const CarruselImages = ({ images }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const numberPhotos = useRef(4);
  const { width } = useWindowDimensions();

  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      setIsDarkMode(true);
    }
  }, []);

  useEffect(() => {
    if (width >= 1956) {
      numberPhotos.current = 6;
    } else if (width >= 1850) {
      numberPhotos.current = 5;
    } else if (width >= 1400) {
      numberPhotos.current = 4;
    } else if (width >= 800) {
      numberPhotos.current = 3;
    } else {
      numberPhotos.current = 1;
    }
  }, []);

  const getItemToShow = () => {
    if (numberPhotos.current >= images.length) {
      if (images.length === 1) {
        return 2;
      } else {
        return images.length - 1;
      }
    } else {
      return numberPhotos.current;
    }
  };

  return (
    <Carousel
      activeSlideIndex={activeSlide}
      onRequestChange={setActiveSlide}
      itemsToShow={getItemToShow()}
      containerProps={{
        style: {
          width: "100%",
          height: "100%",
          justifyContent:
            images.length > numberPhotos.current && width > 800
              ? "space-between"
              : "center",
        },
      }}
      backwardBtnProps={{
        children: (
          <img
            src={isDarkMode ? iconPreviousWhite : iconPrevious}
            className="imgLeft"
            alt={"previous"}
          />
        ),
        style: {
          width: 60,
          height: 60,
          minWidth: 60,
          alignSelf: "center",
          position: "absolute",
          bottom: -50,
          marginRight: 60,
          backgroundColor: "transparent",
          border: 0,
          cursor: "pointer",
        },
      }}
      forwardBtnProps={{
        children: (
          <img
            src={isDarkMode ? iconNextWhite : iconNext}
            className="imgRight"
            alt={"next"}
          />
        ),
        style: {
          width: 60,
          height: 60,
          minWidth: 60,
          alignSelf: "center",
          position: "absolute",
          bottom: -50,
          marginLeft: 60,
          backgroundColor: "transparent",
          border: 0,
          cursor: "pointer",
        },
      }}
    >
      {images.map((image, index) => {
        return (
          <div className="card-container" key={index}>
            <div className="image-container">
              <img src={image} alt={"principal"} />
            </div>
            <div className="footer-image not-width">
              <div className="not-width"></div>
              <div className="icon-container not-width">
                <img
                  src={download}
                  alt={`download-${index + 1}`}
                  onClick={() => {
                    saveAs(`${image}?original=true`);
                  }}
                />
              </div>
              <div className="not-width">
                <p>{`${index + 1}/${images.length}`}</p>
              </div>
            </div>
          </div>
        );
      })}
    </Carousel>
  );
};
